var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoisePattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "greenNoise"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "matrix",
    values: "                0  0  0  0  0                0  0.2  0  0  0                0  0  0.1  0  0                0  0  0  0.8  0         "
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    filter: "url(#greenNoise)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoisePattern);
export default __webpack_public_path__ + "static/media/noisePattern.3172ad4ceea8bfaa058b7803f3115d9b.svg";
export { ForwardRef as ReactComponent };